module.exports = __webpack_public_path__ + "assets/certificate_pdf/Statistical Knowledge Today_1120707.aebafc62.pdf";